import VideoconferenceRegistration from './main';
import { connect } from 'react-redux';
import { videoconferenceActions } from 'core/Videoconference';

const mapStateToProps = state => ({
    status: state.videoconference.status,
    videoconference: state.videoconference.videoconference
});

const mapDispatchToProps = {
    createVideoconference: videoconferenceActions.createVideoconference,
    deleteVideoconference: videoconferenceActions.deleteVideoconference,
    editVideoconference: videoconferenceActions.editVideoconference,
    getVideoconference: videoconferenceActions.getVideoconference,
    setVideoconferenceVideoconference: videoconferenceActions.setVideoconferenceVideoconference
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoconferenceRegistration);
